<template>
  <v-dialog
    persistent
    v-model="model"
    max-width="350px"
    transition="dialog-bottom-transition"
    content-class="ads-dialog"
  >
    <v-card v-if="ads" elevation="0" class="ma-0 pa-2 py-4" color="primary">
      <v-img :src="ads.photo" :contain="true" max-height="150px">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              width="2"
              indeterminate
              color="white"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <v-row class="ma-0 pa-0 mt-5 px-5" justify="center">
        <p class="ads-title">{{ ads.title }}</p>
      </v-row>
      <v-row class="ma-0 pa-0 mt-2 px-2" justify="center">
        <p class="ads-text">{{ ads.text }}</p>
      </v-row>
      <v-row class="ma-0 pa-0 mt-2 mx-5 px-5" justify="center">
        <v-btn
          @click="confirmClick()"
          color="white"
          class="text-none primary--text"
          block
          x-large
        >
          <p class="ma-0 pa-0 ads-text primary--text">
            {{ ads.confirm_button }}
          </p>
        </v-btn>
      </v-row>
    </v-card>
    <v-btn
      v-if="ads"
      @click="closeClick()"
      x-large
      elevation="0"
      text
      color="white"
      class="text-none ads-close-button"
    >
      <p class="ma-0 pa-0 ads-text">
        {{ ads.close_button }}
      </p>
    </v-btn>
  </v-dialog>
</template>

<style>
.ads-dialog {
  box-shadow: unset !important;
  -webkit-box-shadow: unset !important;
}
.ads-close-button {
  margin-top: 60px;
}
.ads-title {
  font-size: 26px;
  line-height: 32px;
  color: white;
  font-weight: bold;
  text-align: center;
}
.ads-text {
  font-size: 18px;
  line-height: 24px;
  color: white;
  font-weight: normal;
  text-align: center;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import adsServices from "@/services/ads.services.js";
export default {
  methods: {
    ...mapActions("general", [
      "logEvent",
      "openExternalUrl",
      "openInternalUrl",
    ]),
    async getAvailableAds() {
      if (["admin", "dev"].includes(process.env.VUE_APP_ENV)) {
        this.ads = null;
        this.model = false;
        return;
      }

      this.requestTime =
        this.requestTime || localStorage.getItem("vetalfa-ads")
          ? parseInt(localStorage.getItem("vetalfa-ads"))
          : null;

      const getAvailableAdsCondition =
        !!this.user &&
        !this.loading &&
        (!this.requestTime ||
          this._getElapsedSeconds(this.requestTime) / 3600 > 1);

      if (
        getAvailableAdsCondition &&
        this.$route.name !== "update" &&
        this.$route.name !== "home"
      ) {
        this.loading = true;
        try {
          this.ads = await adsServices.getAds();

          this.requestTime = this._getTimestamp();
          localStorage.setItem("vetalfa-ads", this.requestTime);

          this.model = !!this.ads;
          if (this.model) {
            this.logEvent({
              name: "adsDisplay",
              object: { user: this.user.uid, ads: this.ads.ads_uid },
            });
          }
        } catch {
          this.ads = null;
          this.model = false;
        } finally {
          this.loading = false;
        }
      }
    },
    confirmClick() {
      this.postClick(true);
    },
    closeClick() {
      this.postClick(false);
    },
    async postClick(confirm) {
      try {
        this.loading = true;
        this.model = false;
        this.logEvent({
          name: confirm ? "adsConfirm" : "adsClose",
          object: { user: this.user.uid, ads: this.ads.ads_uid },
        });
        await adsServices.postAdsClick(
          {
            confirm,
            elapsedSeconds: this._getElapsedSeconds(this.requestTime),
          },
          this.ads.ads_uid,
          this.user.uid
        );
      } catch {
        this.logEvent({
          name: "adsConfirmationError",
          object: { user: this.user.uid, ads: this.ads.ads_uid },
        });
      } finally {
        this.loading = false;
        if (confirm) {
          this.redirectToLink(this.ads);
        }
      }
    },
    redirectToLink() {
      if (!this.ads.external) {
        this.openInternalUrl({
          url: this.ads.url,
        });
      } else {
        this.openExternalUrl({
          url: this.ads.url,
          inAppBrowser: true,
        });
      }
    },
  },
  watch: {
    $route: {
      handler: function () {
        this.getAvailableAds();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("general", ["user"]),
  },
  data() {
    return {
      model: false,
      requestTime: null,
      loading: false,
      ads: null,
    };
  },
  created() {},
};
</script>
